/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {reverseTransaction} from '../api'

export const useMutationReverseTransaction = createReactQueryMutationHook('reverseTransaction', reverseTransaction)
